import React, {Suspense, memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type ChevronProps = {
    isRTL?: boolean
    placement: string
    handleClick: (event: React.MouseEvent<EventTarget>) => void
    show: boolean
    chevronIconAltText: string
    realm: string
    variant?: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

const Chevron = memo((props: ChevronProps) => {
    const {mainTemplate, fallbackTemplate} = props.templating
    const TemplatedChevron = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)

    return (
        <Suspense>
            <TemplatedChevron {...props} />
        </Suspense>
    )
})

Chevron.displayName = "Chevron"

export default connect(Chevron)
